<template>
    <div class="default-page">
        <div class="buttons">
            <!--            <button class="button btn-primary"-->
            <!--                    v-if="getPermissionSection('create')"-->
            <!--                    @click="goToCreate">-->
            <!--                {{ $ml.get('buttons.create') }}-->
            <!--            </button>-->

            <button :class="['button', button.class]" :key="index"
                    v-for="(button, index) in buttons"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <TableFilter
            v-if="getPermissionSection('view_search')"
            @resetFilter="resetFilter"
            @applyFilter="applyFilter"
            :filter="filter"
            :filter-open="filterOpen"/>

        <div class="block" v-if="getPermissionSection('view_list')">
            <div class="title">{{ dashboardTitle }}</div>
            <div class="body">
                <Table :paginate-count="paginateCount"
                       :page="page"
                       :last_page="last_page"
                       @setPage="setPage">
                    <template slot="thead">
                        <Thead :header="tableHeader" :is-counter="tableHeaderChange" @sortBy="sortBy"/>
                    </template>
                    <template slot="tbody">
                        <tr v-for="item in listItems" :key="item.id">
                            <td>
                                {{ item.id }}
                            </td>
                            <td v-for="(col, index) in tableHeader"
                                v-if="col.key !== 'id'"
                                :key="index"
                                :class="[{'text-left': col.key === 'title'}, col.classes ? col.classes : '']">

                                <template v-if="tableBody[col.key]">
                                    <template v-if="tableBody[col.key].type === 'string'">
                                        {{ item[col.key] }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'boolean'">
                                        {{ getBooleanValue(item[col.key]) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'dictionary'">
                                        {{ getDictionaryValue(tableBody[col.key], item) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'concat'">
                                        {{ getConcatValue(tableBody[col.key], item) }}
                                    </template>
                                    <template v-if="tableBody[col.key].type === 'function'">
                                        <div v-html="tableBody[col.key].function(item)"></div>
                                    </template>
                                </template>
                                <template v-else-if="col.key === 'activated'">
                                    <select class="select"
                                            @change="saveItem(item)"
                                            v-model="item.activated">
                                        <option v-for="item in filtersDefault.activated.options"
                                                :value="item.id">
                                            {{ item.title }}
                                        </option>
                                    </select>
                                </template>
                                <template v-else-if="col.key === 'buttons'">
                                    <!--                                    <a class="button btn-primary"-->
                                    <!--                                       v-if="getPermissionSection('edit')"-->
                                    <!--                                       :title="$ml.get('interface.edit')"-->
                                    <!--                                       :href="getLinkEdit(item.id)">-->
                                    <!--                                        <span class="icon ico-i icon-edit"></span>-->
                                    <!--                                    </a>-->
                                    <button class="button btn-primary"
                                            :title="lang.buttons.export"
                                            @click="handleExport(item)">
                                        {{ lang.buttons.export }}
                                    </button>
                                </template>
                                <template v-else>
                                    {{ item[col.key] }}
                                </template>
                            </td>
                        </tr>
                    </template>
                </Table>
            </div>
        </div>

        <div class="block ">
            <div class="title">Generate QR codes</div>

            <div class="body flex-row-wrap" @keyup.enter="generateCodes">
                <div class="w25" v-for="(item, key) in generateForm">
                    <div class="formBlock">
                        <p class="label">{{ item.label }}</p>
                        <input type="number" class="input"
                               v-if="item.type==='number'"
                               :placeholder="item.label"
                               v-model="generateForm[key].value">
                        <input type="text" class="input"
                               v-if="item.type==='text'"
                               :placeholder="item.label"
                               v-model="generateForm[key].value">
                        <!--                        <select v-model="generateForm[key].value" class="select"-->
                        <!--                                v-else-if="item.type==='select'">-->
                        <!--                            <option :value="null">Not selected</option>-->
                        <!--                            <option v-for="(option, id) in item.options" :value="option.id">-->
                        <!--                                {{ option[item.title ? item.title : 'title'] }}-->
                        <!--                            </option>-->
                        <!--                        </select>-->
                        <div class="defaultMultiselect" v-else-if="item.type==='select'">
                            <Multiselect
                                track-by="id"
                                :label="item.title ? item.title : 'title'"
                                v-model="generateForm[key].value"
                                :options="item.options"
                                :placeholder="item.label">
                                <template v-slot="noResult">
                                    {{ $ml.get('interface.no_result') }}
                                </template>
                                <template v-slot="noOptions">
                                    {{ $ml.get('interface.no_options') }}
                                </template>
                            </Multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer">
                <button class="button" @click="generateCodes">
                    Generate
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import ListDefault from "../../Utils/Page/ListDefault";
import dayjs from "dayjs";
import Multiselect from "vue-multiselect";

export default {
    name: "QrCodeList",

    components: {Multiselect},

    mixins: [ListDefault],

    data() {
        return {
            lang: this.$ml.get('pages.qrCode'),

            filter: {
                code: {value: null, type: 'text'},
                note: {value: null, type: 'text'},
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                {key: 'id', is_sort: true},
                {key: 'note', is_sort: false, classes: 'text-l'},
                {key: 'label_size', is_sort: false, classes: 'text-l'},
                {key: 'pages', is_sort: false, classes: 'text-l'},
                {key: 'print_border', is_sort: false, classes: 'text-l'},
                {key: 'created_at', is_sort: true, classes: 'text-l'},
            ],

            tableBody: {
                created_at: {type: 'function', function: this.getCreatedAtLabel},
            },

            generateForm: {
                note: {label: 'Note', value: null, type: 'text'},
                pages: {label: 'Pages', value: 1, type: 'number'},
                //quantity_per_line: { label: 'Quantity per line', value: 2, type: 'number' },
                print_border: {
                    label: 'Print border',
                    value: {id: false, title: 'No'},
                    type: 'select',
                    options: [
                        {id: true, title: 'Yes'},
                        {id: false, title: 'No'},
                    ]
                },
                format: {
                    label: 'Format',
                    value: {id: '1.4', title: '1.5\"'},
                    type: 'select',
                    options: [
                        //{id: 'A5', title: 'A5'},
                        //{id: 'A4', title: 'A4'},
                        {id: '1', title: '1\"'},
                        {id: '1.4', title: '1.5\"'},
                    ]
                },
            },

            apiList: this.$store.getters.getApiUrl('marketing.qr_code'),
            pageRoute: 'qr_code',
            pageRouteCreate: 'qr_code.create',
            pageRouteEdit: 'qr_code.edit',
            pagePermission: 'marketing.qr_code',
        }
    },

    methods: {
        getCreatedAtLabel(item) {
            return item.created_at ? dayjs(item.created_at).format('MM/DD/YYYY HH:mm:ss') : '-'
        },
        generateCodes() {
            this.$store.commit('setLoading', true)
            let data = {
                note: this.generateForm.note.value,
                pages: this.generateForm.pages.value,
                //quantity_per_line: this.generateForm.quantity_per_line.value,
                print_border: this.generateForm.print_border.value.id,
                format: this.generateForm.format.value.id,
            }
            axios.post(this.$store.getters.getApiUrl('marketing.qr_code.generate'), data, {responseType: 'blob'})
                .then(async (response) => {
                    await this.download(new Blob([response.data]), this.generateForm.note.value)
                    this.generateForm.note.value = ''
                    this.getData()
                }).finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        handleExport(item) {
            this.$store.commit('setLoading', true)
            const data = {
                QRCodesPackId: item.id
            }
            axios.post(this.$store.getters.getApiUrl('marketing.qr_code.export'), data, {responseType: 'blob'})
                .then(async (response) => {
                    await this.download(new Blob([response.data]), item.note)
                }).finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        async download(blob, filename = null) {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            console.log('filename 1', filename)
            if (!filename) {
                filename = 'Generated codes'
            }
            console.log('filename', filename);
            link.href = url;
            link.setAttribute('download', `${filename}.pdf`);
            document.body.appendChild(link);
            link.click();
        }
    }
}
</script>
